export default "__VITE_ASSET__xw9Pm2Rq__ 1200w";